import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByCategory',
})
export class FilterItemByCategoryPipe  implements PipeTransform {
  transform(items: Array<any>, category: string): unknown {

    if (!items || !category) {
      return items;
    }
    return items.filter(item => item.group === category);
  }
}
